export default __webpack_public_path__ + "static/media/logo.244a0c9f.svg";